import { isDevMode } from '@angular/core';
import { AbstractControl, ValidatorFn } from '@angular/forms';
import { FormConfigService } from 'src/app/services/form-config.service';
import { DispoEpargneValidatorsFactory } from 'src/fieldFormControl/validators/dispoEpargneValidator';
import { MontantValidatorsFactory } from 'src/fieldFormControl/validators/montantValidator';
import { ObjectifsValidatorsFactory } from 'src/fieldFormControl/validators/objectifValidator';
import { SharedValidatorsFactory } from 'src/fieldFormControl/validators/sharedValidator';
import { NoValidatorError } from 'src/fieldFormControl/validators/ValidatorErrors';
import { VersementInitialMontantValidatorFactory } from 'src/fieldFormControl/validators/VersementlValidator';
import { VersementComplementaireMontantValidatorFactory } from 'src/fieldFormControl/validators/VersementlValidator';

export class ValidatorsFactory {
  static applyErrorMessageDecorator(
    fieldKey: string,
    validatorKey: string,
    config: FormConfigService,
    validator: ValidatorFn
  ): ValidatorFn {
    if (!validator) {
      return validator;
    } else {
      return (control: AbstractControl) => {
        const validationError = validator(control);
        if (validationError) {
          const code = fieldKey + '_' + validationError['code'];
          validationError[code] = true;
          validationError['code'] = code;
          if (isDevMode()) {
            console.log(validationError);
          }
        }
        return validationError;
      };
    }
  }

  static getValidator(fieldKey: string, validatorKey: string, config: FormConfigService): ValidatorFn {
    let validator: ValidatorFn | undefined = undefined;
    // try to get validator from block specific validators
    switch (fieldKey) {
      case 'montant':
        validator = MontantValidatorsFactory.getValidator(validatorKey, config);
        break;
      case 'objectifs':
        validator = ObjectifsValidatorsFactory.getValidator(validatorKey, config);
        break;
      case 'disponibiliteEpargne':
        validator = DispoEpargneValidatorsFactory.getValidator(validatorKey, config);
        break;
      case 'versements.versementInitial.montantBrut':
        validator = VersementInitialMontantValidatorFactory.getValidator(fieldKey, validatorKey, config);
        break;
      case 'versements.versementComplementaire.montantBrut':
        validator = VersementComplementaireMontantValidatorFactory.getValidator(fieldKey, validatorKey, config);
        break;
      default:
      // do nothing
    }

    // if no validator found, try to get it from shared Validators
    if (validator) {
      return this.applyErrorMessageDecorator(fieldKey, validatorKey, config, validator) as ValidatorFn;
    } else {
      validator = SharedValidatorsFactory.getValidator(fieldKey, validatorKey, config);
      if (validator) {
        return this.applyErrorMessageDecorator(fieldKey, validatorKey, config, validator) as ValidatorFn;
      }
    }

    throw new NoValidatorError(fieldKey, validatorKey);
  }
}
